<div class="heka-m3-dialog-container-basic">
@if(title) {
  <div class="dialog-header">
    <h4>{{title}}</h4>
  </div>
  }
  <mat-dialog-content class="dialog-content">
    <div>
      {{description}}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-flat-button color="primary" mat-dialog-close>{{buttonTitle}}</button>
  </mat-dialog-actions>
</div>
